import { accountTerminationProductsRoute } from './1AccountTerminationProductsPage/route';
import { accountTerminationSettlementRoute } from './2AccountTerminationSettlementPage/route';
import { accountTerminationSummaryRoute } from './3AccountTerminationSummaryPage/route';
import { accountTerminationRoute } from './route';

export const accountTerminationRoutes = accountTerminationRoute.addChildren([
	accountTerminationProductsRoute,
	accountTerminationSettlementRoute,
	accountTerminationSummaryRoute,
]);
